import $ from 'jquery';

const $body = $(document.body);
const bodyData = $body.data();
const userId = bodyData.userId || 0;

function isElementInView(element, fullyInView) {
	var pageTop = $(window).scrollTop();
	var pageBottom = pageTop + $(window).height();
	var elementTop = $(element).offset().top;
	var elementBottom = elementTop + $(element).height();

	if (fullyInView === true) {
		return pageTop < elementTop && pageBottom > elementBottom;
	} else {
		return elementTop <= pageBottom && elementBottom >= pageTop;
	}
}

const $elementsToCheck = $('.js-check-me-for-in-view');
const timerIndexes = {};
if ($elementsToCheck.length > 0) {
	function checkElements() {
		$elementsToCheck.each(function (index) {
			if (isElementInView(this, false)) {
				const $question = $(this);
				if (!$question.data('is-seen')) {
					$question.data('is-seen', true);
					if (timerIndexes[index]) clearTimeout(timerIndexes[index]);
					if (isElementInView($question[0], false)) {
						timerIndexes[index] = setTimeout(() => {
							$.ajax({
								url:
									'/stat/Bericht bekeken/' +
									$question.data('question-type') +
									'/' +
									userId +
									'/' +
									$question.data('question-id'),
							});
						}, 2000);
					}
				}
			}
		});
	}
	$(window).scroll(checkElements);
	checkElements();
}

export default isElementInView;
